module.exports = __webpack_public_path__ + "media/images/lps-hobby-2971d77d.png";